import { defineStore } from 'pinia';

export const useLoadingStore = defineStore('loading', {
  state: () => ({
    is: false
  }),
  actions: {
    setLoading(status) {
      this.is = status;
    }
  }
});